import { Skeleton } from "@mui/material";
import classNames from "classnames";

import { RobotoTypography } from "@/shared/components";
import { EventRecord } from "@/shared/domain/events";
import { useTopicById } from "@/shared/domain/topics/hooks/useTopic";
import { EntityIcon } from "@/shared/foundation/icons";
import { ErrorOutlineIcon } from "@/shared/foundation/icons/mui";

import styles from "./Scopes.module.css";
import { useViewTopic } from "./useViewTopic";

interface AssociatedTopicProps {
  topicId: string;
  event: EventRecord;
}

export function AssociatedTopic({ topicId, event }: AssociatedTopicProps) {
  const topicQuery = useTopicById(topicId);
  const viewTopic = useViewTopic();

  if (topicQuery.isPending) {
    return <Skeleton variant="text" width="150px" />;
  }

  if (topicQuery.isError) {
    return (
      <span className={styles.container}>
        <ErrorOutlineIcon color="error" className={styles.icon} />
        <RobotoTypography component={"span"} className={styles.text}>
          Failed to load topic
        </RobotoTypography>
      </span>
    );
  }

  return (
    <span className={styles.container}>
      <EntityIcon type="topic" size="1em" className={styles.icon} />
      <RobotoTypography
        component={"a"}
        className={classNames("ph-no-capture", styles.text, styles.link)}
        onClick={() => viewTopic(topicQuery.data.topic_name, event)}
        title={topicQuery.data.topic_name}
      >
        {topicQuery.data.topic_name}
      </RobotoTypography>
    </span>
  );
}
